import React, { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";

function Listuser() {
  const [editData, setEditData] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("");
  const [cellnumber, setCellnumber] = useState("");
  const [civilstatus, setCivilstatus] = useState("Single");
  const [religion, setReligion] = useState("N/A");
  const [nationality, setNationality] = useState("");
  const [occupation, setOccupation] = useState("");
  const [recentaddress, setRecentaddress] = useState("");
  const [presentaddress, setPresentaddress] = useState("");
  // const [username, setUsername] = useState("");
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [role, setRole] = useState("member");
  const [selectedBrgyId, setSelectedBrgyId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [userData, setuserData] = useState(null);
  const rowsPerPage = 10;

  const navigate = useNavigate();
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [isSearchboxVisible, setSearchboxVisible] = useState(false);

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/listuser?firstname=${firstname}`
      )
      .then((res) => {
        setuserData(res.data);
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleEdit = (userData) => {
    setIsEditVisible(!isEditVisible);
    setSearchboxVisible(!isSearchboxVisible);

    // Set text data to the desired textbox information to update
    setEditData(userData);
    setSelectedBrgyId(userData.brgyId);
    // setUsername(userData.username);
    // setEmail(userData.email);
    // setPassword(userData.password);
    // setRole(userData.role);
    setFirstname(userData.firstname);
    setMiddlename(userData.middlename);
    setLastname(userData.lastname);
    setAge(userData.age);
    setBirthdate(userData.birthdate);
    setGender(userData.gender);
    setCellnumber(userData.cellnumber);
    setCivilstatus(userData.civilstatus);
    setReligion(userData.religion);
    setNationality(userData.nationality);
    setOccupation(userData.occupation);
    setRecentaddress(userData.recentaddress);
    setPresentaddress(userData.presentaddress);
    // console.log("password:" + password);
    console.log("checkbdateformat:" + birthdate);
  };

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleCancel = () => {
    setFirstname("");
    setIsEditVisible(false);
    setEditData(null);
  };

  const handleclose = () => {
    navigate("/officerpage");
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(userData.users.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentUsers = userData
    ? userData.users.slice(startIndex, endIndex)
    : [];

  return (
    <div className="officerpage-parent parent-height">
      <AutoLogout />
      <div className={`container ${isEditVisible ? "edit-mode" : ""}`}>
        <div className="searchbox">
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className="datagrid-parent">
          <button
            type="btn"
            className="closebtn"
            onClick={handleclose} //close the page and back to login page
          >
            X
          </button>
          <h1>List of Users</h1>
          {currentUsers.length > 0 ? (
            <div className="datagrid-holder">
              <table>
                <thead>
                  <tr>
                    <th>BrgyId</th>
                    <th>First Name</th>
                    <th>Family Name</th>
                    <th>Gender</th>
                    <th>Phone</th>
                    <th>Recentaddress</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user) => (
                    <tr key={user.brgyId}>
                      <td>{user.brgyId}</td>
                      <td>{user.firstname}</td>
                      <td>{user.lastname}</td>
                      <td>{user.gender}</td>
                      <td>{user.cellnumber}</td>
                      <td>{user.recentaddress}</td>
                      <td
                        className="handleEdit"
                        onClick={() => handleEdit(user)}>
                        View
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-controls">
                <button
                  className="pagination-button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="pagination-info">
                  Page {currentPage} of{" "}
                  {Math.ceil(userData.users.length / rowsPerPage)}
                </span>
                <button
                  className="pagination-button"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(userData.users.length / rowsPerPage)
                  }>
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p className="noUsertext">No users available for display.</p>
          )}
        </div>
      </div>
      {/* edit form  */}
      {editData && (
        <div className="Updateform-parent">
          <div className="updateform-holder">
            <h1>User Information</h1>
            <div className="autonumbers">
              <label>BrgyId:{selectedBrgyId}</label>
            </div>
            <form className="formUpdate-boxcontainers">
              <div className="photo-container">
                <img src={editData.photo} alt="User Photo" />
              </div>
              <label>User Information</label>
              <div className="userinfo-container">
                <div>
                  <label htmlFor="firstname">First name:</label>
                  <input
                    type="text"
                    placeholder="Enter Firstname"
                    value={firstname}
                    readOnly
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="middlename">Middle Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Middle Name"
                    value={middlename}
                    readOnly
                    onChange={(e) => setMiddlename(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="lastname">Last Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Family Name"
                    value={lastname}
                    readOnly
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="age">Age:</label>
                  <input
                    type="text"
                    placeholder="Enter Age"
                    value={age}
                    readOnly
                    min="0" // Specify minimum age
                    maxLength={3} // Set the maximum length to 3
                    pattern="[0-9]*" // Allow only numeric values
                    onKeyPress={(e) => {
                      // Allow only numeric characters and the Enter key
                      if (isNaN(e.key) && e.key !== "Enter") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      // Remove non-numeric characters
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );

                      // Update the state with the numeric value
                      setAge(numericValue);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor="Birth-Date">Birth Date:</label>
                  <input
                    type="date"
                    placeholder="Enter Birth-Date"
                    readOnly
                    value={birthdate}
                    onChange={(e) => setBirthdate(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="Gender">Gender:</label>
                  <select
                    value={gender}
                    disabled
                    onChange={(e) => setGender(e.target.value)}>
                    <option value="Not Set">Not Set</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="cellnumberNumber">Contant Number:</label>
                  <input
                    type="text"
                    placeholder="Enter cellnumber Number"
                    readOnly
                    pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                    value={cellnumber}
                    onChange={(e) => {
                      const formattedValue = e.target.value.replace(
                        /[^0-9 ]/g,
                        ""
                      );

                      // Update the state with the formatted value
                      setCellnumber(formattedValue);
                    }}
                  />
                  <small>Format: 0000 000 0000</small>
                </div>
                <div>
                  <label htmlFor="civilstatus">Civil Status:</label>
                  <select
                    value={civilstatus}
                    disabled
                    onChange={(e) => setCivilstatus(e.target.value)}>
                    <option value="Single">Single</option>
                    <option value="Separated">Separated</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="religion">Religion:</label>
                  <select
                    value={religion}
                    disabled
                    onChange={(e) => setReligion(e.target.value)}>
                    <option value="N/A">N/A</option>
                    <option value="Roman Catholic">Roman Catholic</option>
                    <option value="INC">INC</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="Nationality">Nationality:</label>
                  <select
                    value={nationality}
                    disabled
                    onChange={(e) => setNationality(e.target.value)}>
                    <option value="Not Set">Not Set</option>
                    <option value="Filipino">Filipino</option>
                    <option value="US">US</option>
                    <option value="INDIA">INDIA</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="occupation">Occupation:</label>
                  <select
                    value={occupation}
                    disabled
                    onChange={(e) => setOccupation(e.target.value)}>
                    <option value="None">None</option>
                    <option value="Labor">Labor</option>
                    <option value="Farmer">Farmer</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="recentaddress">Recentaddress:</label>
                  <input
                    type="text"
                    value={recentaddress}
                    readOnly
                    onChange={(e) => setRecentaddress(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="presentaddress">Presentaddress:</label>
                  <input
                    type="text"
                    readOnly
                    value={presentaddress}
                    onChange={(e) => setPresentaddress(e.target.value)}
                  />
                </div>
              </div>
              <button className="closebtn" type="button" onClick={handleCancel}>
                X
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Listuser;
